import React, { useEffect, useState } from 'react';
import Footer from "../ui-components/footer";
import Navigationbar from "../ui-components/navbar";
import { Outlet } from "react-router-dom";
import { getRequest } from '../utilities/server-utils';
import '../App.css';



export default function Root(){
    const [settings, setSettings] = useState(null);
    const [currentPath, setCurrentPath] = useState(null);

    
    useEffect(()=>{
        setCurrentPath(window.location.pathname);
        console.log("Current path: " + currentPath);
        const getSettings = async()=>{
            await getRequest("/admin/auth/settings/")
            .then(response => {
                if(response.status === 200){
                    setSettings(response.data[0]);
                }
            })
            .catch(error=>{
                alert("Error getting settings from the server: " + error.request.status);
            })
        }

        getSettings();
    }, [currentPath])

    return ( 
        <div className="root_layout jetbrains-mono-regular">
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-9ndCyUaIbzAi2FUVXJi0CjmCapSmO7SnpJef0486qhLnuZ2cdeRhO02iuK6FUUVM" crossOrigin="anonymous"></link>
            <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-geWF76RCwLtnZ8qwWowPQNguL3RmwHVBC9FhGdlKrxdiJJigb/j/68SIy3Te4Bkz" crossOrigin="anonymous"></script>
            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,200,0,0" />

            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap" rel="stylesheet"></link>

            <Navigationbar />
            {
                settings !== null
                &&
                settings.show_note === true
                &&
                <div className='row mt-5'>
                    <div className='col-md-12'>
                        <div className='w-100 bg-red-100 pt-2 absolute top-12'>
                            <p className='font-bold text-md text-rose-700'>{settings && settings.note_title}</p>
                            <p>{settings && settings.note_message}</p>
                        </div>
                    </div>
                </div>
            }
            

            <Outlet />
            <Footer />
        </div>
    );
}


